<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay  @keydown.esc="close()" transition="dialog-bottom-transition">
        <v-card>
            
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Seleciona Documento</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="selecionar()">Selecionar</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="pa-0">
                
                <v-expansion-panels focusable>
                    
                    <v-expansion-panel>
                        <v-expansion-panel-header>Filtros</v-expansion-panel-header>
                        <v-expansion-panel-content>

                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-autocomplete v-model="filtro.doadorId" :items="doadores" :loading="isDoadorLoading" :search-input.sync="searchDoador" hide-no-data hide-selected cache-items clearable
                                        item-text="cpfCnpjNome" item-value="id" label="Doador" placeholder="Digite um doador"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-autocomplete v-model="filtro.projetoId" :items="projetos" :loading="isProjetoLoading" :search-input.sync="searchProjeto" hide-no-data hide-selected cache-items clearable
                                        item-text="codigoNome" item-value="id" label="Projeto" placeholder="Digite um projeto"/>
                                </v-col>
                            </v-row>

                            <v-row align="center">
                                <v-col cols="12" md="2">
                                    <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                        <template v-slot:activator="{on}">
                                            <v-text-field type="date" v-model="filtro.vencimentoInicial" label="Vencimento Inicial" :rules="fieldRules" dense outlined>
                                                <template v-slot:prepend>
                                                    <v-icon v-on="on">mdi-calendar</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker locale="pt-br" v-model="filtro.vencimentoInicial" no-title dense outlined/>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="1" class="body-1" align="center">
                                    até
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                        <template v-slot:activator="{on}">
                                            <v-text-field type="date" v-model="filtro.vencimentoFinal" label="Vencimento Final" :rules="fieldRules" dense outlined>
                                                <template v-slot:prepend>
                                                    <v-icon v-on="on">mdi-calendar</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker locale="pt-br" v-model="filtro.vencimentoFinal" no-title dense outlined/>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="2"/>
                                <v-col cols="12" md="2">
                                    <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                        <template v-slot:activator="{on}">
                                            <v-text-field type="date" v-model="filtro.pagamentoInicial" label="Pagamento Inicial" :rules="fieldRules" dense outlined>
                                                <template v-slot:prepend>
                                                    <v-icon v-on="on">mdi-calendar</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker locale="pt-br" v-model="filtro.pagamentoInicial" no-title dense outlined/>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="1" class="body-1" align="center">
                                    até
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                        <template v-slot:activator="{on}">
                                            <v-text-field type="date" v-model="filtro.pagamentoFinal" label="Pagamento Final" :rules="fieldRules" dense outlined>
                                                <template v-slot:prepend>
                                                    <v-icon v-on="on">mdi-calendar</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker locale="pt-br" v-model="filtro.pagamentoFinal" no-title dense outlined/>
                                    </v-menu>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="4">
                                    <v-select v-model="filtro.regiaoId" label="Região/Grupo do Doador" :items="regioes" item-value="id" item-text="nome"/>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-select v-model="filtro.situacao" label="Situação" :items="situacoes" item-value="key" item-text="value"/>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-spacer/>
                                <v-btn color="accent" @click="Atualizar()">Consultar</v-btn>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>

                </v-expansion-panels>

                <v-data-table :headers="headers" :items="lista" sort-by="id" :options.sync="options" :server-items-length="totalLista" :loading="loading" :footer-props="{ showFirstLastPage: true}" 
                    class="elevation-1" show-select single-select v-model="itemSelected">
                    
                    <!-- <template v-slot:body="{ items }">
                        <tbody>
                            <tr v-for="item in items" :key="item.id" >
                                <td>{{ item.id }}</td>
                                <td>{{ item.doador.nome }}</td>
                                <td>{{ item.situacao }}</td>
                                <td>{{ new Date(item.dataVencimento).ddmmyyyy() }}</td>
                                <td>{{ item.dataPagamento ? new Date(item.dataPagamento).ddmmyyyy() : '' }}</td>
                                <td>{{ item.valor.toMoeda() }}</td>
                                <td>{{ item.desconto.toMoeda() }}</td>
                                <td>{{ item.juros.toMoeda() }}</td>
                                <td>{{ item.valorFinal.toMoeda() }}</td>
                                <td>{{ item.descricao }}</td>
                            </tr>
                        </tbody>
                    </template> -->

                    <template v-slot:[`item.dataVencimento`]="{ item }">
                        {{item.dataVencimento ? new Date(item.dataVencimento).ddmmyyyy() : ''}}
                    </template>

                    <template v-slot:[`item.dataPagamento`]="{ item }">
                        {{item.dataPagamento ? new Date(item.dataPagamento).ddmmyyyy() : ''}}
                    </template>

                    <template v-slot:[`item.valor`]="{ item }">
                        {{item.valor.toMoeda()}}
                    </template>

                    <template v-slot:[`item.desconto`]="{ item }">
                        {{item.desconto.toMoeda()}}
                    </template>

                    <template v-slot:[`item.valorFinal`]="{ item }">
                        {{item.valorFinal.toMoeda()}}
                    </template>

                </v-data-table>

            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import DoadorService from '@/core/services/doacao/DoadorService';
import ProjetoService from '@/core/services/projetos/ProjetoService';
import RegiaoService from '@/core/services/doacao/RegiaoService';
import SituacaoFormaPagamentoService from '@/core/services/financeiro/SituacaoFormaPagamentoService';
import RecebivelService from '../../../core/services/financeiro/RecebivelService';

export default {
    props:{
        value: {},
        selectedDocumento: {
            required: true
        }
    },    
    data: () =>({
        options: {
            itemsPerPage: 15
        },
        lista: [],
        totalLista: 0,
        service: new RecebivelService(),
        loading: false,
        dialog: false,
        filtro: {
            doadorId: null,
            projetoId: null,
            regiaoId: null,
            vencimentoInicial: '',
            vencimentoFinal: '',
            pagamentoInicial: '',
            pagamentoFinal: '',
            situacao: 'A',
        },
        isDoadorLoading: false,
        doadores: [],
        searchDoador: null,
        isProjetoLoading: false,
        projetos: [],
        searchProjeto: null,
        regioes: [],
        situacoes: [],
        headers: [
            { text: 'Código', value: 'id', type: 'number' },
            { text: 'Doador', value: 'doador.nome' },
            { text: 'Sit.', value: 'situacaoStr' },
            { text: 'Vencimento', value: 'dataVencimento', type: 'date' },
            { text: 'Pagamento', value: 'dataPagamento', type: 'date' },
            { text: 'Valor', value: 'valor', type: 'number' },
            { text: 'Desc,', value: 'desconto', type: 'number' },
            { text: 'Juros', value: 'juros', type: 'number' },
            { text: 'Total', value: 'valorFinal', type: 'number' },
            { text: 'Descrição', value: 'descricao'},
        ],
        itemSelected: [],
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ]
    }),
    watch:{
        options: {
            handler () {
                this.Atualizar();
            },
            deep: true
        },
        value: function() {
            this.dialog = this.value;
            this.Atualizar();
        },
        searchDoador (val) {
            if (this.isDoadorLoading) return;
            if (!val) return;
            
            this.isDoadorLoading = true
            let doadorService = new DoadorService();
            doadorService.AutoComplete(val)
                .then(
                    res => {
                        this.doadores = res.data;
                    },
                    err => this.$swal('Aviso', err.response.data, 'error')
                )
                .finally(() => (this.isDoadorLoading = false))
        },
        searchProjeto (val) {
            if (this.isProjetoLoading) return;
            if (!val) return;
            
            this.isProjetoLoading = true
            let projetoService = new ProjetoService();
            projetoService.AutoComplete(val)
                .then(
                    res => {
                        this.projetos = res.data;
                    },
                    err => this.$swal('Aviso', err.response.data, 'error')
                )
                .finally(() => (this.isProjetoLoading = false))
        }
    },
    methods: {

        Atualizar(){
            this.loading = true;
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            this.service.ListarComFiltro(page, itemsPerPage, sortBy, sortDesc, this.search, this.headers, this.filtro)
                .then(
                    res => {
                        this.lista = res.data.items; 
                        this.totalLista = res.data.count;
                        this.loading = false;
                    },
                    err => {
                      this.loading = false;
                      this.$swal('Aviso', err.response.data, 'error')
                    }
                );
        },

        selecionar(){            
            this.selectedDocumento.length = 0;
            this.selectedDocumento.push(this.itemSelected[0]);                       
            this.close();        
        },

        close() {
            this.dialog = false;
        }
    },
    beforeUpdate(){
        if(!this.dialog){
            this.$emit('fechou');
        }
    },
    mounted() {
        let situacaoFormaPagamentoService = new SituacaoFormaPagamentoService();
        situacaoFormaPagamentoService.Listar()
          .then(
              res => {
                  this.situacoes = res.data;
                  this.situacoes.unshift({
                    key: null,
                    value: 'TODOS'
                  });
              },
              err => {
                  this.$swal('Aviso', err.message, 'error');
              }
          );

        let regiaoService = new RegiaoService();
        regiaoService.Listar()
          .then(
              res => {
                  this.regioes = res.data.items;
                  this.regioes.unshift({
                    id: null,
                    nome: 'TODOS'
                  });
              },
              err => {
                  this.$swal('Aviso', err.message, 'error');
              }
          );
    }
}
</script>